var Html5QrcodeStrings = (function () {
    function Html5QrcodeStrings() {
    }
    Html5QrcodeStrings.codeParseError = function (exception) {
        return "B\u0142\u0105d skanowania kodu QR, error = ".concat(exception);
    };
    Html5QrcodeStrings.errorGettingUserMedia = function (error) {
        return "Error getting userMedia, error = ".concat(error);
    };
    Html5QrcodeStrings.onlyDeviceSupportedError = function () {
        return "The device doesn't support navigator.mediaDevices , only "
            + "supported cameraIdOrConfig in this case is deviceId parameter "
            + "(string).";
    };
    Html5QrcodeStrings.cameraStreamingNotSupported = function () {
        return "Przeglądarka nie wspiera aparatu.";
    };
    Html5QrcodeStrings.unableToQuerySupportedDevices = function () {
        return "Nie znaleziono urządzeń.";
    };
    Html5QrcodeStrings.insecureContextCameraQueryError = function () {
        return "Dostęp do aparatu tylko dostępny tylko z zabezpieczonych stron.";
    };
    Html5QrcodeStrings.scannerPaused = function () {
        return "Zatrzymano skanowanie";
    };
    return Html5QrcodeStrings;
}());
export { Html5QrcodeStrings };
var Html5QrcodeScannerStrings = (function () {
    function Html5QrcodeScannerStrings() {
    }
    Html5QrcodeScannerStrings.scanningStatus = function () {
        return "Skanowanie";
    };
    Html5QrcodeScannerStrings.idleStatus = function () {
        return "Oczekiwanie";
    };
    Html5QrcodeScannerStrings.errorStatus = function () {
        return "Błąd";
    };
    Html5QrcodeScannerStrings.permissionStatus = function () {
        return "Uprawnienia";
    };
    Html5QrcodeScannerStrings.noCameraFoundErrorStatus = function () {
        return "Brak aparatów";
    };
    Html5QrcodeScannerStrings.lastMatch = function (decodedText) {
        return "Ostatnie dopasowanie: ".concat(decodedText);
    };
    Html5QrcodeScannerStrings.codeScannerTitle = function () {
        return "Skaner kodów";
    };
    Html5QrcodeScannerStrings.cameraPermissionTitle = function () {
        return "Poproś o dostęp do aparatu";
    };
    Html5QrcodeScannerStrings.cameraPermissionRequesting = function () {
        return "Proszenie o dostęp do aparatu...";
    };
    Html5QrcodeScannerStrings.noCameraFound = function () {
        return "Nie znaleziono aparatu";
    };
    Html5QrcodeScannerStrings.scanButtonStopScanningText = function () {
        return "Zatrzymaj skanowanie";
    };
    Html5QrcodeScannerStrings.scanButtonStartScanningText = function () {
        return "Rozpocznij skanowanie";
    };
    Html5QrcodeScannerStrings.torchOnButton = function () {
        return "Switch On Torch";
    };
    Html5QrcodeScannerStrings.torchOffButton = function () {
        return "Switch Off Torch";
    };
    Html5QrcodeScannerStrings.torchOnFailedMessage = function () {
        return "Failed to turn on torch";
    };
    Html5QrcodeScannerStrings.torchOffFailedMessage = function () {
        return "Failed to turn off torch";
    };
    Html5QrcodeScannerStrings.scanButtonScanningStarting = function () {
        return "Uruchamianie aparatu...";
    };
    Html5QrcodeScannerStrings.textIfCameraScanSelected = function () {
        return "Skanuj obrazek";
    };
    Html5QrcodeScannerStrings.textIfFileScanSelected = function () {
        return "Skanuj za pomocą aparatu";
    };
    Html5QrcodeScannerStrings.selectCamera = function () {
        return "Wybierz aparat";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseImage = function () {
        return "Wybierz obrazek";
    };
    Html5QrcodeScannerStrings.fileSelectionChooseAnother = function () {
        return "Wybierz inny";
    };
    Html5QrcodeScannerStrings.fileSelectionNoImageSelected = function () {
        return "Nie wybrano obrazka";
    };
    Html5QrcodeScannerStrings.anonymousCameraPrefix = function () {
        return "Nieznany aparat";
    };
    Html5QrcodeScannerStrings.dragAndDropMessage = function () {
        return "Albo upuść obrazek do skanowania";
    };
    Html5QrcodeScannerStrings.dragAndDropMessageOnlyImages = function () {
        return "Albo upuść obrazek do skanowania (inne pliki nie są wspierane)";
    };
    Html5QrcodeScannerStrings.zoom = function () {
        return "przybliż";
    };
    Html5QrcodeScannerStrings.loadingImage = function () {
        return "Ładowanie obrazka...";
    };
    Html5QrcodeScannerStrings.cameraScanAltText = function () {
        return "Skanowanie za pomocą aparatu";
    };
    Html5QrcodeScannerStrings.fileScanAltText = function () {
        return "Fule based scan";
    };
    return Html5QrcodeScannerStrings;
}());
export { Html5QrcodeScannerStrings };
var LibraryInfoStrings = (function () {
    function LibraryInfoStrings() {
    }
    LibraryInfoStrings.poweredBy = function () {
        return "Powered by ";
    };
    LibraryInfoStrings.reportIssues = function () {
        return "Zgłoś błąd";
    };
    return LibraryInfoStrings;
}());
export { LibraryInfoStrings };
//# sourceMappingURL=strings.js.map